export default __webpack_public_path__ + "static/media/diamont.3cec241c.JPG";